export const paths = {
  session: '/iphone_spa/migration/session',
};
